export default __webpack_public_path__ + "static/media/health_record.e4170bc0.svg";